import React from 'react';

export const withDataLayerWrapper =
  ({
    Component,
    position,
    isWrapped = true,
  }: {
    Component: any;
    position: string;
    isWrapped?: boolean;
  }) =>
  (props: any) => {
    // Not wrapped is an explicit assignment making sure the component involved WILL NOT RENDER if there is not "position"
    if (!isWrapped) return <Component {...props} datalayerPosition={position} />;

    return (
      <div data-datalayer-position={position} style={{ width: '100%' }}>
        <Component {...props} />
      </div>
    );
  };
